import type { LucideIcon } from 'lucide-react';
import { Clapperboard, Copy, History, Layers, Presentation, Puzzle, ShoppingBag } from 'lucide-react';
import type { ApplicationId } from '../services/api';

/**
 * 前端应用展示映射。
 *
 * 应用目录（appId/title/description/path/启停状态）的唯一来源是后端注册表，
 * 通过 GET /api/config/applications[/public] 下发；此处只维护构建期 UI 资产：
 * appId → 图标。后端新增而前端尚未适配的 appId 会回退到 Puzzle 图标。
 */
const applicationIcons: Record<ApplicationId, LucideIcon> = {
  director: Clapperboard,
  canvas: Layers,
  ecommerceReplicate: Copy,
  ecommerceSuite: ShoppingBag,
  ppt: Presentation,
  photoRestore: History,
};

export function getApplicationIcon(appId: string): LucideIcon {
  return applicationIcons[appId as ApplicationId] ?? Puzzle;
}
